import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import AuthService from '../../services/AuthService';
import Loader from '../../components/Loader';
import SubnavBar from '../../components/SubnavBar';
import TitleBar from '../../components/TitleBar';
import List from '../../components/Drivers/List';
import { UserActions } from '../../actions';

export class Drivers extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  static propTypes = {
    auth: PropTypes.instanceOf(AuthService)
  }

  componentWillMount() {
    const { companies } = this.props;
    if (!companies) {
      this.props.dispatch(UserActions.getDrivers());
    }
  }

  newDriver = () => {
    browserHistory.push('/admin/driver');
  }

  render() {
    const { drivers } = this.props;
    const subnavItems = [{ key: 1, label: 'New', onClick: this.newDriver }];
    let content;
    if (!drivers || drivers.fetching || !drivers.list) {
      content = <Loader />;
    } else {
      content = <List drivers={drivers.list} />
    }

    return (
      <div className="grid">
        <div className="unit whole align-center">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Drivers" />
          <div className="grid">
            <div className="unit whole">
              {content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { drivers } = state;
  return {
    drivers
  }
}

export default connect(mapStateToProps)(Drivers);


// WEBPACK FOOTER //
// ./src/containers/Drivers/index.js